import { render } from "./editRelated.vue?vue&type=template&id=030d05ea&scoped=true"
import script from "./editRelated.vue?vue&type=script&lang=js"
export * from "./editRelated.vue?vue&type=script&lang=js"

import "./editRelated.vue?vue&type=style&index=0&id=030d05ea&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030d05ea"],['__file',"src/views/brand/components/editRelated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "030d05ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('030d05ea', __exports__)) {
    console.log('reload')
    api.reload('030d05ea', __exports__)
  }
  
  module.hot.accept("./editRelated.vue?vue&type=template&id=030d05ea&scoped=true", () => {
    console.log('re-render')
    api.rerender('030d05ea', render)
  })

}


export default __exports__